import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle, Gem } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { loadCharacter } = useAuth();
  const [status, setStatus] = useState("verifying");
  const [gems, setGems] = useState(0);
  const [kind, setKind] = useState("gems");
  const ref = params.get("reference") || params.get("trxref");

  useEffect(() => {
    if (!ref) { setStatus("failed"); return; }
    (async () => {
      try {
        const { data } = await api.get(`/store/paystack/verify/${ref}`);
        if (data.status === "success") {
          setGems(data.gems || 0);
          setStatus("success");
          setKind(data.kind || "gems");
          await loadCharacter();
          toast.success(data.kind === "ad" ? "Ad is live! 📣" : `Payment confirmed! +${data.gems}💎`);
          setTimeout(() => nav(data.kind === "ad" ? "/advertise" : "/store"), 2000);
        } else {
          setStatus("failed");
        }
      } catch (e) {
        toast.error(errMsg(e));
        setStatus("failed");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70dvh] px-8 text-center" data-testid="payment-callback">
      {status === "verifying" && (
        <>
          <Loader2 size={48} className="text-[#16A34A] animate-spin" />
          <h1 className="font-display text-2xl mt-5">Confirming payment…</h1>
          <p className="text-sm text-slate-500 mt-2">Hold on, we dey verify with Paystack.</p>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircle2 size={56} className="text-[#16A34A] neon-text" />
          <h1 className="font-display text-3xl mt-5">{kind === "ad" ? "Ad is Live! 📣" : "Payment Successful 🎉"}</h1>
          {kind === "ad" ? (
            <p className="text-sm text-slate-500 mt-3">Your billboard is now showing in the city.</p>
          ) : (
            <div className="mt-3 flex items-center gap-2 text-[#FFD700] font-display text-xl">
              <Gem size={20} /> +{gems} gems added
            </div>
          )}
          <p className="text-sm text-slate-500 mt-3">Taking you back to the store…</p>
        </>
      )}
      {status === "failed" && (
        <>
          <XCircle size={56} className="text-[#FF0055]" />
          <h1 className="font-display text-2xl mt-5">Payment not confirmed</h1>
          <p className="text-sm text-slate-500 mt-2">No gems were added. If money left your account, it will be reversed.</p>
          <button data-testid="back-to-store" onClick={() => nav("/store")}
            className="mt-6 bg-[#FFD700] text-slate-900 font-bold px-6 py-3 rounded-xl">
            Back to Store
          </button>
        </>
      )}
    </div>
  );
}
